import ClassNames from '@streamloots/classnames';
import { useTranslation } from 'utils/translation';
import { LoadingBar } from 'ui-library/loading-spinner';
import { ButtonIcon, BaseButtonProps } from 'ui-library/button';
import theme from './fetcher-pagination.scss';

const classNames = ClassNames(theme);

interface ShowMoreButtonProps {
  className?: string;
  separatorClassName?: string;
  isLoading?: boolean;
  onClick?: () => void;
  label?: string;
  buttonProps?: BaseButtonProps;
  highlighted?: boolean;
  iconRight?: boolean;
  iconClassNames?: string;
  buttonClassName?: string;
}

export const ShowMoreButton = ({
  className = '',
  separatorClassName = '',
  iconClassNames = '',
  buttonClassName = '',
  onClick,
  buttonProps = {},
  highlighted = false,
  isLoading,
  label,
  iconRight = true,
}: ShowMoreButtonProps): JSX.Element => {
  const { t } = useTranslation('common');
  const labelText = label || t('common:showMore');

  return (
    <div
      className={classNames({
        'show-more': true,
        [className]: Boolean(className),
      })}
    >
      <div
        className={classNames({ 'show-more__separator': true, [separatorClassName]: Boolean(separatorClassName) })}
      />
      {isLoading ? (
        <div className={classNames('show-more__loading')}>
          <LoadingBar />
        </div>
      ) : (
        <ButtonIcon
          small={!highlighted}
          className={classNames({
            'show-more__button': true,
            'show-more__button--default': !highlighted && !buttonProps?.primary,
            'show-more__button--highlighted': highlighted,
            [buttonClassName]: Boolean(buttonClassName),
          })}
          onClick={onClick}
          label={labelText}
          {...buttonProps}
          icon="chevron-down"
          iconRight={iconRight}
          iconClass={iconClassNames}
        />
      )}
      <div
        className={classNames({ 'show-more__separator': true, [separatorClassName]: Boolean(separatorClassName) })}
      />
    </div>
  );
};
